/**
 * NavbarSection — edits the top navigation strings.
 *
 * Path map: nav.{home, features, advantages, faq, contact, tutorials,
 *               signIn, dashboard, switchLanguage, switchLanguageAria,
 *               openMenu, closeMenu}
 *
 * All eight visible link labels + the language-switch label + ARIA hints.
 */

import { BilingualTextField, SectionPanel } from '../fields/BilingualFields'

const NAV_FIELDS = [
  { path: 'nav.home',            label: 'Home' },
  { path: 'nav.features',        label: 'Features' },
  { path: 'nav.advantages',      label: 'Advantages' },
  { path: 'nav.faq',             label: 'FAQ' },
  { path: 'nav.contact',         label: 'Contact' },
  { path: 'nav.tutorials',       label: 'Tutorials' },
  { path: 'nav.signIn',          label: 'Sign in (button)' },
  { path: 'nav.dashboard',       label: 'Dashboard (logged-in button)' },
  { path: 'nav.switchLanguage',  label: 'Language toggle label', hint: 'Shows OTHER language name' },
  { path: 'nav.switchLanguageAria', label: 'Language toggle ARIA label' },
  { path: 'nav.openMenu',        label: 'Mobile menu open ARIA' },
  { path: 'nav.closeMenu',       label: 'Mobile menu close ARIA' },
]

export default function NavbarSection({ getField, setField }) {
  return (
    <SectionPanel title="Navbar" subtitle="Top navigation links + sign-in button + language toggle">
      {NAV_FIELDS.map((f) => (
        <BilingualTextField
          key={f.path}
          label={f.label}
          path={f.path}
          getField={getField}
          setField={setField}
          hint={f.hint}
        />
      ))}
    </SectionPanel>
  )
}
